// slugs of the people that have a detail page -- filled once per app load in
// `app.vue` from `/api/linkable-people` and read by every rendered person name
// (see `shared/person-link.vue`)
export const useLinkablePeopleSlugs = () =>
  useState<Set<string>>('linkable-people-slugs', () => new Set())
